export default __webpack_public_path__ + "static/olympicPark5-d218b6d797cea2b2b0834807ba9a97ec.jpeg";